import Error from '../model/Error.js';
import GalleryAlbum from '../dto/GalleryAlbum.js';
import axios from 'axios';

export default class GalleryRepository {
    static findAll(kindergartenId, params) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/kindergartens/${kindergartenId}/gallery/albums`, { params })
                .then(response => {
                    const data = response.data.data.map(data => GalleryAlbum.fromData(data));
                    const meta = response.data.meta || {};
                    resolve({ data, meta });
                })
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static find(kindergartenId, albumId, params) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/kindergartens/${kindergartenId}/gallery/albums/${albumId}`, { params })
                .then(response => {
                    const data = GalleryAlbum.fromData(response.data.data);
                    resolve(data);
                })
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static createTranslations(albumIds, translationLanguage) {
        return new Promise((resolve, reject) => {
            axios
                .post('/kindergartens/gallery/albums/translations', { ids: albumIds, translationLanguage: translationLanguage })
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
